import React, { useRef } from 'react';

function simpleMarkdownToHtml(md) {
  const raw = md || '';
  // Escape HTML
  let text = raw
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
  // Bold **text**
  text = text.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  // Italic *text*
  text = text.replace(/\*(.+?)\*/g, '<em>$1</em>');
  // Inline code `code`
  text = text.replace(/`([^`]+)`/g, '<code>$1</code>');
  // Paragraphs & line breaks
  const paragraphs = text.split(/\n{2,}/).map((para) => {
    return para.replace(/\n/g, '<br />');
  });
  return paragraphs.map((p) => `<p>${p}</p>`).join('');
}

function MarkdownEditor({ id, value, onChange }) {
  const textareaRef = useRef(null);

  const applyWrap = (wrapper) => {
    const el = textareaRef.current;
    if (!el) return;
    const start = el.selectionStart ?? 0;
    const end = el.selectionEnd ?? 0;
    const text = value || '';
    const before = text.slice(0, start);
    const selected = text.slice(start, end);
    const after = text.slice(end);
    const wrapped = `${wrapper}${selected || ''}${wrapper}`;
    const next = before + wrapped + after;
    onChange(next);
    // restore selection roughly around wrapped text
    const cursor = start + wrapped.length;
    requestAnimationFrame(() => {
      el.focus();
      el.setSelectionRange(cursor, cursor);
    });
  };

  return (
    <div className="MarkdownEditor">
      <div className="MarkdownEditor-toolbar" aria-hidden="true">
        <button
          type="button"
          className="MarkdownEditor-btn"
          onClick={() => applyWrap('**')}
        >
          B
        </button>
        <button
          type="button"
          className="MarkdownEditor-btn"
          onClick={() => applyWrap('*')}
        >
          I
        </button>
        <button
          type="button"
          className="MarkdownEditor-btn"
          onClick={() => applyWrap('`')}
        >
          {'</>'}
        </button>
      </div>

      <div className="MarkdownEditor-body">
        <textarea
          id="eventDescription"
          ref={textareaRef}
          className="MarkdownEditor-textarea"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          rows={4}
          placeholder="Kirjoita kuvaus... Voit käyttää **lihavointia**, *kursivointia* ja `koodia`."
        />
      </div>
    </div>
  );
}

export { simpleMarkdownToHtml };
export default MarkdownEditor;

